import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
	
class EmailRssPreview extends Class{
	
	constructor(){
		super();
		this.navcode = this.getParameterByName('navcode');
		this.request();
	}
	
	request(){
		var self = this;
		$.ajax({
			url: "/magazine/email/email.template.html"
		})
		.done(function(html) {
			var html = html;
			$.ajax({
				url: "/xmlservers/emailrss.aspx?navcode=" + self.navcode
			})
			.done(function(rss) {
				var $rss = $(rss);
				var $filteredRSS = $rss.find('rss channel item description').html().split('"<![CDATA[').join('').split(']]>').join('')
				$(document.body).append(html.split('<rssbody paragraphs="all"></rssbody>').join($filteredRSS));
			});
		})
		
	}
	
	getParameterByName(name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i"),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	}
	
}
export { EmailRssPreview };


// WEBPACK FOOTER //
// ./Javascript/libraries/EmailRssPreview/email.rss.preview.js